import * as React from 'react';
import './search.scss';
import { ReactComponent as ExpertsSvg } from './images/experts.svg';
import { ReactComponent as ExtractSvg } from './images/extract.svg';
import { ReactComponent as HeadSvg } from './images/head.svg';
import { requestSearch, userToken, requestUserInfo, logout, requestExtractor, requestHistory, requestCsv, requestCreateFavList } from '../../model/api';
import { Input, Button, Menu, Cascader, message, Dropdown, Tooltip, Pagination } from 'antd';
import { exportRaw, downloadFile } from '../../utils/file';
import Login from '../login/login';
import Results from '../results';
import RegionOptions from './data/region.json';
import LevelsOptions from './data/levels.json';
import QueryString from 'query-string';

const { TextArea } = Input;

export default class SearchPage extends React.Component {
    _userMenu = (
        <Menu>
            <Menu.Item key="0">
                <div onClick={this.handleLogout.bind(this)}>退出登陆</div>
            </Menu.Item>
        </Menu>
    );
    _keywordsInput = null;

    constructor(props) {
        super(props);

        let params = QueryString.parse(window.location.search);

        let dev_mode = params.dev == '1' || params.dev == 'true';
        this.state = {
            inited: false,
            tab: "search",
            history: [],
            history_page: 1,
            history_total: 0,
            history_limit: 10,
            history_selected: -1,
            loading: false,
            userInfo: null,
            showLogin: false,
            taskId: null,
            taskTotal: 0,
            taskError: false,
            keywords: [],
            keywordsInput: "",
            regions: [],
            levels: [],
            title: "",
            company: "",
            // abstract: "",
            abstract: "Data mining",
            activeExtractor: false,
            mobileLeft: true, 
            export_visible: dev_mode || params.export == '1' || params.export == 'true',
            dev_mode: dev_mode
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleClickUser = this.handleClickUser.bind(this);
        this.showLogin = this.showLogin.bind(this);
        this.requestUserInfo = this.requestUserInfo.bind(this);
        this.handleLoginClose = this.handleLoginClose.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.renderKeywords = this.renderKeywords.bind(this);
        this.handleAddKeywords = this.handleAddKeywords.bind(this);
        this.handleRemoveKeywords = this.handleRemoveKeywords.bind(this);
        this.renderRegions = this.renderRegions.bind(this);
        this.handleAddRegion = this.handleAddRegion.bind(this);
        this.handleRemoveRegion = this.handleRemoveRegion.bind(this);
        this.renderLevels = this.renderLevels.bind(this);
        this.handleAddLevel = this.handleAddLevel.bind(this);
        this.handleRemoveLevel = this.handleRemoveLevel.bind(this);
        this.handleAdvSearch = this.handleAdvSearch.bind(this);
        this.handleExtract = this.handleExtract.bind(this);
        this.addKeywords = this.addKeywords.bind(this);
        this.handleAbstractChange = this.handleAbstractChange.bind(this);
        this.handleClickHistory = this.handleClickHistory.bind(this);
        this.handleSelectHistory = this.handleSelectHistory.bind(this);
        this.handleHistoryPageChange = this.handleHistoryPageChange.bind(this);
        this.requestHistoryPage = this.requestHistoryPage.bind(this);
        this.handleClickFavourite = this.handleClickFavourite.bind(this);
        this.handleAddFavourite = this.handleAddFavourite.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleExport = this.handleExport.bind(this);
    }

    componentDidMount() {
        this.requestUserInfo();
    }

    requestUserInfo() {
        if (userToken()) {
            requestUserInfo(userToken()).then(data => {
                if (data.data && data.data.length) {
                    let result = data.data[0];
                    if (result.succeed && result.items && result.items.length) {
                        this.setState({ userInfo: result.items[0] })
                    }
                }
            })
        }
    }

    handleLoginClose() {
        this.requestUserInfo();
        this.setState({ showLogin: false });
    }

    handleLogout() {
        logout();
        this.setState({ userInfo: null })
    }

    handleAdvSearch() {
        if (this.state.loading) return;
        if (!this.state.abstract) {
            message.error("Abstract 不能为空！");
        } else {
            this.setState({ loading: true, inited: true, taskId: null, mobileLeft: false })
            let levels = [...this.state.levels];
            if(levels.indexOf('new_star') >= 0) levels.push('junior');
            let body = {
                search_type: "adv",
                resp_type: "json",
                abstract: this.state.abstract,
                title: this.state.title,
                keywords: this.state.keywords.map(d => d.label),
                trans_kw: "zh2en",
                filter: {
                    region: this.state.regions,
                    levels: levels
                }
            }
            requestSearch(body).then(data => {
                if (data.status == 0) {
                    let taskId = data.data.id;
                    let taskTotal = data.data.experts;
                    this.setState({ taskId, taskTotal, loading: false, taskError: false })
                } else {
                    this.setState({ loading: false, taskError: true});
                }
            })
        }
    }

    handleExport() {
        if (!this.state.abstract) {
            message.error("Abstract 不能为空！");
        } else {
            let levels = [...this.state.levels];
            if(levels.indexOf('new_star') >= 0) levels.push('junior');
            let body = {
                abstract: this.state.abstract,
                title: this.state.title,
                keywords: this.state.keywords.map(d => d.label),
                trans_kw: "zh2en",
                filter: {
                    region: this.state.regions,
                    levels: levels
                }
            }
            requestCsv(body).then(data => {
                if (data) {
                    downloadFile(`export_reco_${new Date().getTime()}.csv`, data);
                }
            })
        }
    }

    handleInputChange(e) {
        this.setState({ searchStr: e.target.value });
    }

    handleClickUser(e) {
        if (!this.state.userInfo) {
            this.showLogin();
        }
        e.stopPropagation();
    }

    showLogin() {
        this.setState({ showLogin: true });
    }

    handleExtract() {
        if (this.state.abstract) {
            requestExtractor(this.state.abstract).then(data => {
                if (data && data.status == 0) {
                    let keywords = [...this.state.keywords];
                    let len = keywords.length;
                    while(--len > -1) {
                        if(keywords[len].ai) {
                            keywords.splice(len, 1);
                        }
                    }
                    data.data.forEach(d => {
                        let exist = keywords.find(k => k.label == d[0]);
                        if(!exist) {
                            keywords.unshift({label: d[0], ai: true});
                        }
                    });
                    this.setState({keywords});
                }
            })
            this.setState({ activeExtractor: false });
        }
    }

    addKeywords(label, ai) {
        let keywords = [...this.state.keywords];
        let index = keywords.findIndex(d => d.label == label);
        if(index >= 0) {
            if(!ai && keywords[index].ai) {
                keywords.splice(index, 1);
                keywords.push({label, ai});
            }
        }else {
            keywords.push({label, ai});
        }
        this.setState({keywords});
    }  

    handleAddKeywords() {
        if(this.state.keywordsInput) {
            this.addKeywords(this.state.keywordsInput, false);
            this.setState({keywordsInput: ""});
            setTimeout(() => {
                this._keywordsInput.focus();
            }, 1000);
        }
    }

    handleRemoveKeywords(value) {
        let keywords = [...this.state.keywords];
        let index = keywords.findIndex(d => d.label == value);
        if (index >= 0) {
            keywords.splice(index, 1);
        }
        this.setState({ keywords })
    }

    renderKeywords() {
        const { keywords, keywordsInput, activeExtractor } = this.state;
        let result = keywords.map((d, i) => <div className='tag' key={i}>{d.label}<i className='fas fa-times' onClick={() => this.handleRemoveKeywords(d.label)} style={{ userSelect: 'none', cursor: "pointer" }} />{d.ai && <div className='ailine'/>}</div>);
        result.push(
            <div className='add' key={-1}>
                <Input className='input' ref={r => this._keywordsInput = r} value={keywordsInput} placeholder="添加关键词" onChange={(e) => this.setState({ keywordsInput: e.target.value })} onPressEnter={this.handleAddKeywords} />
                <i className='fas fa-plus' onClick={this.handleAddKeywords} />
            </div>
        )
        result.push(
            <div className={`extract${activeExtractor ? " active" : ""}`} key={-2} onClick={this.handleExtract}>
                <ExtractSvg />自动抽取
            </div>
        )
        return result;
    }

    handleAddRegion(value) {
        if (value.length) {
            value = value[value.length - 1];
            if (this.state.regions.indexOf(value) < 0) {
                this.setState({ regions: [...this.state.regions, value] });
            }
        }
    }

    handleRemoveRegion(value) {
        let regions = [...this.state.regions];
        let index = regions.indexOf(value);
        if (index >= 0) {
            regions.splice(index, 1);
        }
        this.setState({ regions })
    }

    renderRegions() {
        const { regions } = this.state;
        let result = regions.map((d, i) => <div className='tag' key={i}>{d}<i className='fas fa-times' onClick={() => this.handleRemoveRegion(d)} style={{ userSelect: 'none', cursor: "pointer" }} /></div>);
        result.push(
            <div className='add' key={-1}>
                <Cascader
                    className='region_input'
                    options={RegionOptions}
                    onChange={(value) => this.handleAddRegion(value)}
                    placeholder=""
                    displayRender={() => <span style={{ color: 'lightgrey' }}>添加地区</span>}
                    allowClear={false}
                    suffixIcon={""} />
                <i className='fas fa-plus' style={{ pointerEvents: "none" }} />
            </div>
        )
        return result;
    }

    handleAddLevel(value) {
        if (value.length) {
            value = value[0];
            if (this.state.levels.indexOf(value) < 0) {
                this.setState({ levels: [...this.state.levels, value] });
            }
        }
    }

    handleRemoveLevel(value) {
        let levels = [...this.state.levels];
        let index = levels.indexOf(value);
        if (index >= 0) {
            levels.splice(index, 1);
        }
        this.setState({ levels })
    }

    levelText(id) {
        let item = LevelsOptions.find(d => d.value == id);
        return item ? item.label : "";
    }

    renderLevels() {
        const { levels } = this.state;
        let result = levels.map((d, i) => <div className='tag' key={i}>{this.levelText(d)}<i className='fas fa-times' onClick={() => this.handleRemoveLevel(d)} style={{ userSelect: 'none', cursor: "pointer" }} /></div>);
        result.push(
            <div className='add' key={-1}>
                <Cascader className='region_input' options={LevelsOptions} onChange={(value) => this.handleAddLevel(value)} placeholder="" displayRender={() => <span style={{ color: 'lightgrey' }}>添加类型</span>} allowClear={false} autoFocus={false} />
                <i className='fas fa-plus' style={{ pointerEvents: "none" }} />
            </div>
        )
        return result;
    }

    handleAbstractChange(e) {
        this.setState({ abstract: e.target.value, activeExtractor: !!e.target.value });
    }

    handleClickFavourite() {
        this.setState({tab: "favourite"});
    }

    handleAddFavourite() {
        // requestMyFavList().then(data => {
        //     console.log("fav list: ", data);
        // })
        requestCreateFavList("test", "test").then(data => {
            console.log("create fav: ", data);
        })
    }

    handleClickHistory() {
        this.setState({tab: "history", history_page: 1, history_selected: -1});
        this.requestHistoryPage()
    }

    handleSelectHistory(index) {
        if(this.state.history_selected != index) {
            let selected = this.state.history[index];
            this.setState({history_selected: index, inited: true, taskId: selected.id, taskTotal: selected.total, mobileLeft: false});
        }
    }

    handleHistoryPageChange(page) {
        this.setState({history_page: page, history_selected: -1});
        setTimeout(() => {
            this.requestHistoryPage();
        }, 200)
    }

    requestHistoryPage() {
        requestHistory(this.state.history_page, this.state.history_limit).then(data => {
            if(data && data.status == 0) {
                this.setState({history: data.data, history_total: data.pagination.total_count});
            }
        })
    }

    handleReset() {
        this.setState({keywords: [], regions: [], levels: [], title: "", abstract: "", company: ""});
    }

    render() {
        const { loading, tab, userInfo, showLogin, title, abstract, company, inited, taskId, taskTotal, taskError, history, history_selected, history_limit, history_page, history_total, mobileLeft } = this.state;
        const isMobile = document.body.offsetWidth < 560;
        return (
            <div className='searchpage' >
                <div className='search_left' style={inited ? { width: isMobile ? (mobileLeft ? '90%' : '10%') : '30%' } : undefined} onClick={isMobile && inited && !mobileLeft ? () => this.setState({mobileLeft: true}) : undefined}>
                    <div className='search_bg' />
                    <div className='search_top' >
                        {
                            (!isMobile || mobileLeft) && (
                            <div className='logo' style={inited ? { height: '100px' } : undefined}>
                                <div className='title' style={inited ? { left: '12px', top: '12px', transform: 'none' } : undefined}><ExpertsSvg />{this.props.title || "学术合作"}</div>
                            </div>)
                        }
                        {
                            userInfo ? (
                                <Dropdown overlay={this._userMenu} trigger={['click']}>
                                    <div className='user' onClick={this.handleClickUser}>
                                        <div className='img'>
                                            {userInfo && userInfo.img ? <img src={userInfo.img} /> : <HeadSvg />}
                                        </div>
                                        { (!isMobile || mobileLeft) && <div className='name'>{userInfo ? userInfo.name : "Login"}</div>}
                                    </div>
                                </Dropdown>
                            ) : (
                                <div className='user' onClick={this.handleClickUser}>
                                    <div className='img'>
                                        {userInfo && userInfo.img ? <img src={userInfo.img} /> : <HeadSvg />}
                                    </div>
                                    { (!isMobile || mobileLeft) && <div className='name'>{userInfo ? userInfo.name : "Login"}</div>}
                                </div>
                            )
                        }
                        {
                            (!isMobile || mobileLeft) && userInfo && (
                                <div className='tools'>
                                    {
                                        tab != "search" && (
                                            <div className='tab_title'>
                                                <i className='fas fa-arrow-left' onClick={() => this.setState({tab: "search"})} />
                                                <span>{tab == 'history' ? '推荐记录' : "我的收藏"}</span>
                                            </div>
                                        )
                                    }
                                    {/* {
                                        tab == 'search' && (
                                            <Tooltip title="我的收藏" onClick={this.handleClickFavourite}>
                                                <i className='fas fa-star' />
                                            </Tooltip>
                                        )
                                    } */}
                                    {
                                        tab == 'search' && (
                                            <Tooltip title="推荐记录" onClick={this.handleClickHistory}>
                                                <i className='fas fa-history' />
                                            </Tooltip>
                                        )
                                    }
                                    {
                                        tab == 'favourite' && (
                                            <Tooltip title="添加收藏夹" onClick={this.handleAddFavourite}>
                                                <i className='fas fa-plus' />
                                            </Tooltip>
                                        )
                                    }
                                </div>
                            )
                        }
                    </div>
                    { 
                        (!isMobile || mobileLeft) && (
                            <div className='search_mid'>
                                {
                                    tab == "search" && (
                                        <div className='advsearch'>
                                            <div className='adv_content'>
                                                <table className='adv_table' cellPadding={isMobile ? "4" : "12"} width='100%'>
                                                    <tbody>
                                                        {/* {
                                                            isMobile && (
                                                                <tr>
                                                                    <td className='title'>标题:</td>
                                                                </tr>
                                                            )
                                                        } */}
                                                        {/* <tr>
                                                            { !isMobile && <td className='title'>标题:</td>}
                                                            <td><Input className='td_input' value={title} onChange={(e) => this.setState({ title: e.target.value })} /></td>
                                                        </tr> */}
                                                        {
                                                            isMobile && (
                                                                <tr>
                                                                    <td className='title'>需求描述:</td>
                                                                </tr>
                                                            )
                                                        }
                                                        <tr>
                                                            { !isMobile && <td className='title'>需求描述:</td>}
                                                            <td><TextArea className='abstract' value={abstract} onChange={this.handleAbstractChange} /></td>
                                                        </tr>
                                                        {
                                                            isMobile && (
                                                                <tr>
                                                                    <td className='title'>关键词:</td>
                                                                </tr>
                                                            )
                                                        }
                                                        <tr>
                                                            { !isMobile && <td className='title'>关键词:</td>}
                                                            <td className='tags'>{this.renderKeywords()}</td>
                                                        </tr>
                                                        {
                                                            isMobile && (
                                                                <tr>
                                                                    <td className='title'>地区:</td>
                                                                </tr>
                                                            )
                                                        }
                                                        <tr>
                                                            { !isMobile && <td className='title'>地区:</td>}
                                                            <td className='tags'>{this.renderRegions()}</td>
                                                        </tr>
                                                        {
                                                            isMobile && (
                                                                <tr>
                                                                    <td className='title'>合作形式:</td>
                                                                </tr>
                                                            )
                                                        }
                                                        <tr>
                                                            { !isMobile && <Tooltip title='选择顾问专家会推荐领域内资深专家，选择技术指导会推荐领域内中青年专家' placement='topLeft' mouseEnterDelay={1}><td className='title'>合作形式:</td></Tooltip>}
                                                            <Tooltip title='选择顾问专家会推荐领域内资深专家，选择技术指导会推荐领域内中青年专家' placement='topLeft' mouseEnterDelay={1}><td className='tags'>{this.renderLevels()}</td></Tooltip>
                                                        </tr>
                                                        {
                                                            isMobile && (
                                                                <tr>
                                                                    <td className='title'>公司名称:</td>
                                                                </tr>
                                                            )
                                                        }
                                                        <tr>
                                                            { !isMobile && <td className='title'>公司名称:</td>}
                                                            <td><Input className='td_input' placeholder='您所在的公司名称，选填' value={company} onChange={(e) => this.setState({ company: e.target.value })} /></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="title_submit">
                                                    <Button className='submit' onClick={this.handleAdvSearch} disabled={loading}>推荐专家</Button>
                                                    { this.state.export_visible && <div className='reset' onClick={this.handleReset}>导出</div>}
                                                    <div className='reset'>
                                                        {this.state.export_visible && <span style={{marginRight: '6px'}} onClick={this.handleExport}>导出</span>}
                                                        <span onClick={this.handleReset}>重置</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    tab == "history" && (
                                        <div className='history_list'>
                                            {history.map((d, i) => {
                                                return (
                                                    <div className='history' key={i} style={i == history_selected ? {backgroundColor: '#3d3a2a90'} : undefined} onClick={() => this.handleSelectHistory(i)}>
                                                        <div className='history_title'>{d.input.title || "无标题"}</div>
                                                        <div className='history_date'>{d.create_time}</div>
                                                        <Tooltip title={d.input.abstract}>
                                                            <div className='history_abstract'>{d.input.abstract}</div>
                                                        </Tooltip>
                                                    </div>
                                                )
                                            })}
                                            {
                                                Math.ceil(history_total/history_limit) > 1 && (
                                                    <div className='pagination'>
                                                      <Pagination defaultCurrent={history_page} total={history_total} pageSize={history_limit} showQuickJumper showSizeChanger={false} onChange={this.handleHistoryPageChange}/>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                    { (!isMobile || mobileLeft) && <div className='footer'>© 2005-2020 AMiner 京ICP备17059297号-2</div>}
                </div>
                {
                    inited && (
                        <div className='search_right'>
                            <div className='result_con'>
                                <Results id={taskId} total={taskTotal} error={taskError} onShowLogin={this.showLogin} dev_mode={this.state.dev_mode} />
                            </div>
                            { mobileLeft && <div className='right_mask' onClick={() => this.setState({ mobileLeft: false })}/>}
                            { mobileLeft && <i className='fa fa-arrow-right' onClick={() => this.setState({inited: false, mobileLeft: true})}/>}
                        </div>
                    )
                }
                {showLogin && <Login onClose={this.handleLoginClose} />}
            </div>
        )
    }
}